import { useEffect, useState, useSyncExternalStore } from 'react'
import { AsyncAction } from '../domain/asyncAction'

export function useAsyncAction<T = unknown>() {
  const [action] = useState(() => new AsyncAction<T>())
  const state = useSyncExternalStore(action.subscribe, action.getSnapshot, action.getSnapshot)
  useEffect(() => () => action.cancel(), [action])
  return { ...state, pending: state.status === 'pending', run: action.run }
}
